import jsPDF from "jspdf";

async function getImageFromUrl(url) {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export async function generarTicket(form, folioId) {
    const anchoTicket = 78;
    const margenLateral = 2;
    const anchoContenido = anchoTicket - (margenLateral * 2);
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [anchoTicket, 330],
    });

    const anchoUtil = anchoContenido;
    const centroTicketX = anchoTicket / 2;
    const fechaHora = `${form.fecha} ${form.hora}`;
    const folioTicket =
        folioId ||
        form?.id ||
        form?.folio ||
        form?.folioId ||
        `TMP-${Date.now()}`;
    let y = 5;

    const imageUrl = '/img/iconn.png';
    const logoData = await getImageFromUrl(imageUrl);

    if (logoData) {
        const logoWidth = 20;
        const logoHeight = 20;
        const logoX = (anchoTicket - logoWidth) / 2;
        doc.addImage(logoData, "PNG", logoX, 2, logoWidth, logoHeight);
        y += 24;

        doc.setFontSize(6.5);
        doc.setFont(undefined, "bold");
        doc.text(`Fecha Y Hora: ${fechaHora}`, centroTicketX, y, { align: "center" });
        y += 4;
    }

    const anchoMaximo = anchoUtil; // 58 mm total - 1 mm margen izquierdo - 1 mm margen derecho
    const lineHeight = 4;    // altura entre líneas

    // Función auxiliar para texto largo
    const agregarTexto = (texto) => {
        const lineas = doc.splitTextToSize(texto, anchoMaximo);
        lineas.forEach(linea => {
            doc.text(linea, margenLateral, y); // x = 1 mm margen izquierdo
            y += lineHeight;
        });
    };

    doc.setFontSize(7.5);
    doc.setFont(undefined, "bold");

    const lineasEncabezado = [
        "H. Ayuntamiento Constitucional de Ixtapaluca",
        "Acciones fuertes",
        "Dirección General de Seguridad y Prevención ciudadana",
        "BOLETA DE INFRACCION"
    ];

    lineasEncabezado.forEach(texto => {
        const lineas = doc.splitTextToSize(texto, anchoUtil);
        lineas.forEach(linea => {
            doc.text(linea, centroTicketX, y, { align: "center" });
            y += 4;
        });
    });

    doc.setFontSize(6.5);
    doc.setFont(undefined, "bold");
    const folioTexto = doc.splitTextToSize(`FOLIO: ${folioTicket}`, anchoUtil);
    folioTexto.forEach(linea => {
        doc.text(linea, margenLateral, y);
        y += 4;
    });

    doc.setFont(undefined, "normal");
    doc.text("----------------------------------------------", margenLateral, y); y += 3;

    const textoLegal = "EL C. AGENTE QUE SUSCRIBE ESTA BOLETA, ESTA FACULTADO PARA PONER LAS SANCIONES PREVISTAS EN LA DISPOSICION DEL REGLAMENTO DE TRANSITO DEL ESTADO DE MEXICO, ASI COMO PARA HACER CONSTAR LOS HECHOS QUE MOTIVE LA INFRACCION EN TERMINOS DEL ARTICULO 16 Y 115 DE LA CONSTITUCION POLITICA DE LOS ESTADOS UNIDOS MEXICANOS, 112 DE LA CONSTITUCION POLITICA DEL ESTADO DE MEXICO 8.18, 8.19 FRACCION II INCISO A)B)C)D) 8.19 BIS, 8.20,8.21, 8.22 DEL LIBRO OCTAVO DEL CODIGO ADMINISTRATIVO DEL ESTADO DE MEXICO ARTICULOS 2,12,13,14,103,104,105,115,116, 118,119,120 Y 126 DEL REGLAMENTO DE TRANSITO DEL ESTADO DE MEXICO";
    y = addWrappedText(doc, textoLegal, margenLateral, y, anchoUtil);

    doc.setFont(undefined, "normal");
    doc.text("----------------------------------------------", margenLateral, y); y += 3;

    doc.setFont(undefined, "bold");
    doc.text("EL CIUDADANO:", margenLateral, y); y += 4;

    doc.setFont(undefined, "normal");
    const nombreCompleto = [form.nombre, form.apellidoPaterno, form.apellidoMaterno]
        .filter((valor) => valor !== null && valor !== undefined && String(valor).trim() !== "")
        .map((valor) => String(valor).trim())
        .join(" ");
    doc.text(nombreCompleto || "N/A", margenLateral, y); y += 4;

    doc.setFont(undefined, "bold");
    doc.text("EL VEHICULO:", margenLateral, y); y += 4;
    doc.setFont(undefined, "normal");
    doc.text(`MARCA: ${form.marca}  SUBMARCA: ${form.submarca}`, margenLateral, y); y += 4;
    doc.text(`MODELO: ${form.modelo}  COLOR: ${form.color}`, margenLateral, y); y += 4;
    doc.text(`SERIE: ${form.serieAuto}`, margenLateral, y); y += 4;
    doc.text(`PLACAS: ${form.placas}`, margenLateral, y); y += 4;

    doc.setFont(undefined, "bold");
    doc.text("----------------------------------------------", margenLateral, y); y += 3;
    doc.text("INFRACCION", margenLateral, y); y += 4;

    doc.setFont(undefined, "bold");
    doc.text("ARTICULOS RELACIONADOS", margenLateral, y); y += 4;

    doc.setFont(undefined, "normal");
    let articulosTexto = form.articulos;
    if (typeof articulosTexto === "string") {
        try {
            const parsed = JSON.parse(articulosTexto);
            if (Array.isArray(parsed)) {
                articulosTexto = parsed.join("\n");
            }
        } catch (e) {}
    } else if (Array.isArray(articulosTexto)) {
        articulosTexto = articulosTexto.join("\n");
    }
    y = addWrappedText(doc, articulosTexto || "", margenLateral, y, anchoUtil);


    doc.setFont(undefined, "bold");
    doc.text("----------------------------------------------", margenLateral, y); y += 3;
    doc.text("SANCION", margenLateral, y); y += 4;

    doc.setFont(undefined, "bold");
    doc.text(`CANTIDAD DE UMAs : ${form.cantidadUMAs || 0}`, margenLateral, y); y += 4;

    doc.setFont(undefined, "normal");
    doc.text("CON RETENCION DE:", margenLateral, y); y += 4;

    doc.setFont(undefined, "normal");
    y = addWrappedText(doc, form.seRetuvo, margenLateral, y, anchoUtil);

    doc.setFont(undefined, "bold");
    doc.text("----------------------------------------------", margenLateral, y); y += 3;
    doc.text("MOTIVACION", margenLateral, y); y += 4;
    doc.setFont(undefined, "normal");

    doc.text(`FECHA/HORA: ${fechaHora}`, margenLateral, y); y += 4;
    agregarTexto(`EN LA CALLE: ${form.calle}`);
    agregarTexto(`ENTRE: ${form.entreCalle}`);
    agregarTexto(`Y: ${form.yCalle}`);
    agregarTexto(`MUNICIPIO: ${form.municipio}`);
    agregarTexto(`COLONIA: ${form.colonia}`);

    y = addWrappedText(doc, `MOTIVO: ${form.motivo}`, margenLateral, y, anchoUtil);

    doc.setFont(undefined, "bold");
    const folioInventarioText = doc.splitTextToSize(`FOLIO DE INVENTARIO: ${form.folioInventario}`, anchoUtil);
    folioInventarioText.forEach(linea => {
        doc.text(linea, margenLateral, y);
        y += 4;
    });

    const depositoText = doc.splitTextToSize(`DEPOSITO (CORRALÓN): ${form.deposito}`, anchoUtil);
    depositoText.forEach(linea => {
        doc.text(linea, margenLateral, y);
        y += 4;
    });

    doc.setFont(undefined, "bold");
    doc.text("----------------------------------------------", margenLateral, y); y += 3;
    doc.text("FORMA DE PAGO", margenLateral, y); y += 4;
    doc.setFont(undefined, "normal");

    y = addWrappedText(doc, "SE TENDRA DERECHO A UN DESCUENTO DEL 70% CUANDO LAS MULTAS SEAN PAGADAS AL MOMENTO, 50% CUANDO LAS MULTAS SEAN PAGADAS DENTRO DE LOS 15 DIAS NATURALES SIGUIENTES A LA FECHA DE LA IMPOSICION DE LA INFRACCION, LAS MULTAS NO PAGADAS DENTRO DEL PLAZO QUE SEÑALA EL ARTICULO 30 DEL CODIGO FINANCIERO DEL ESTADO DE MEXICO, CAUSARAN ACTUALIZACION, SE RETENDRAN LOS DOCUMENTOS QUE ESTIPULE EL ARTICULO 8.19 FRACCION II DEL CODIGO ADMINISTRATIVO DEL ESTADO DE MEXICO, RECUERDA QUE AL ESTAR AL CORRIENTE EN TUS PAGOS DE INFRACCIONES TE PERMITE REALIZAR TUS TRAMITES DE CONTROL VEHICULAR. TRANSITO MUNICIPAL DE IXTAPALUCA SE SITUA EN HACIENDA DE SANTA BARBARA IXTAPALUCA, EDO. DE MEX. A TRAVES DE SUS SISTEMA ADMINISTRATIVO DE INFRACCIONES DE TRANSITO, EL ARTICULO 128 CONTRA LAS SANCIONES QUE SE ES RESPONSABLE RECABAR SUS DATOS PERSONALES, DE USO Y PROTECCION, EN CUMPLIMIENTO DE LA LEY DE PROTECCION DE DATOS PERSONALES DEL ESTADO DE MEXICO, EL TRAMITE ES PERSONAL.", margenLateral, y, anchoUtil);

    doc.setFont(undefined, "bold");
    doc.text("----------------------------------------------", margenLateral, y); y += 3;

    doc.setFont(undefined, "normal");
    doc.text(`AGENTE: ${form.nombreAgente || "____________________"} ${form.nominaAgente || ""}`, margenLateral, y); y += 6;

    doc.text("______________________________", centroTicketX, y, { align: "center" }); y += 4;
    doc.text("Firma del agente", centroTicketX, y, { align: "center" }); y += 6;

    doc.text("______________________________", centroTicketX, y, { align: "center" }); y += 4;
    doc.text("Firma del ciudadano", centroTicketX, y, { align: "center" }); y += 6;

    doc.save(`ticket_infraccion_${folioTicket}.pdf`);
}

function addWrappedText(doc, text, x, y, maxWidth = 56, lineHeight = 3.5) {
    const lines = doc.splitTextToSize(text, maxWidth);
    for (let i = 0; i < lines.length; i++) {
        doc.text(lines[i], x, y);
        y += lineHeight;
    }
    return y;
}

